import InvoiceItemModel from "./InvoiceItemModel";
import {faFileInvoiceDollar} from "@fortawesome/free-solid-svg-icons";
import ImageModel from "../../media/models/ImageModel";
import CompanyModel from "../../companies/models/CompanyModel";
import DocumentModel from "@jadecharles/pi-react-packages/dist/content/models/DocumentModel";
import PaymentModel from "./PaymentModel";

class InvoiceModel { 
    static entityType = 8;
    static icon = faFileInvoiceDollar;

    static create = (json) => new InvoiceModel(json);
    
    constructor(json) {
        if (!json) json = {};
        
        this.id = json.id || null;
        this.label = json.label || '';

        this.companyId = json.company_id || null;
        this.userId = json.user_id || null;

        this.description = json.description || '';
        this.invoiceNumber = json.invoice_number || 0;
        this.invoiceNumberDisplay = json.invoice_number_display || '';
        this.invoiceNumberId = json.invoice_number_id || 0;
        this.total = json.total || 0;
        this.subtotal = json.subtotal || 0;
        this.totalQty = json.total_qty || 0;
        this.tax = json.tax || 0;
        this.lineItemCount = json.line_item_count || 0;
        this.userId = json.userId || "";
        this.imageId = json.imageId || "";
        this.fileUrl = json.file_url || "";
        this.receiptUrl = json.receipt_url || "";
        this.dueAmount = json.due_amount || 0;

        this.image = new ImageModel(json.image);
        this.documents = DocumentModel.fromJsonArray(json.documents);
        
        this.company = CompanyModel.create(json.company);
        
        /**
         * Deprecated - Use userId instead
         * @type {string}
         */
        this.createdBy = json.user_id || "";
        
        this.items = InvoiceItemModel.fromJsonArray(json.items);
        this.payments = PaymentModel.fromJsonArray(json.payments);
        this.summary = InvoiceItemModel.fromJsonArray(json.summary) || [];

        this.sentDate = json.sent_date ? new Date(json.sent_date) : null;
        this.paidDate = json.paid_date ? new Date(json.paid_date) : null;
        this.dueDate = json.due_date ? new Date(json.due_date) : null;
        
        this.created = json.created ? new Date(json.created) : new Date();
        this.modified = json.modified ? new Date(json.modified) : null;
        this.invoiceDate = json.invoice_date ? new Date(json.invoice_date) : this.created;
    }

    /**
     * Adds an item to the invoice and returns the new total
     * @returns {float} - The new total
     * @param item {InvoiceItemModel} The item to add to the invoice
     */
    addItem(item) { 
        this.items.push(item);
        return this.update();
    }

    /**
     * Removes an item from the invoice and returns whether the item was removed
     * @param index {int} - The index of the item to remove
     * @returns {boolean} - Whether something was removed or not
     */
    removeItemAtIndex(index) {
        if (index < 0 || index >= this.items.length)
            return false;
        
        this.items.splice(index, 1);
        
        this.update();
        
        return true;
    }
    
    update() {
        let t = this.items.reduce((total, item) => total + (item.qty * item.price), 0);
        let q = this.items.reduce((total, item) => total + item.qty, 0);

        this.lineItemCount = this.items.length;
        this.subtotal = t;
        this.totalQty = q;
        this.total = this.tax + this.subtotal;

        return this.total;
    }

    getItemsJsonArray() {
        return this.items?.map(item => item.toJson()) || [];
    }
}

export default InvoiceModel;
